import React from 'react';
import { Card, CardContent, Typography, Stack, Box, Avatar } from '@mui/material';

import remo from '../../../../../../Assets/Image/remo.svg';

const CallSubmittedCard = ({ selectedAssistant, employee, selectedAssistantId , phoneNumber }) => (
	<Card
		sx={(theme) => ({
			borderRadius: 3,
			boxShadow: 2,
			width: {xs : '99%', md : '773px' },
			maxWidth:{xs : '99%', md : '773px' },
			mx: 'auto',
			mt: 2,
			bgcolor: theme.palette.primary.lightest_shade,
		})}
	>
		<CardContent sx={{ px: { xs : 1 , md : 5}, py: {  xs : 3, md : 4} }}>
			<Stack direction="column" alignItems="center" spacing={2} px={{ xs : 1, md : 3}} mb={6}>
				<Stack
					sx={(theme) => ({
						width: { xs : '140px' ,md :'180px'},
						height:  { xs : '140px' ,md :'180px'},
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						border: `2px solid ${theme.palette.primary.light_shade}`,
						borderRadius: '50%',
						backgroundColor: theme.palette.primary.lighter_shade,
					})}
				>
					<Avatar
						src={remo}
						alt="Call Submitted"
						imgProps={{ loading: 'lazy' }} // Add this line
						sx={{
							borderRadius: 0,
							bgcolor: 'transparent', // Ensure no background color
							width: { xs : '100px' ,md :'120px'}, // Set width for the Avatar component itself
							height: 'auto', // Maintain aspect ratio
							'& .MuiAvatar-img': {
								// Correct syntax with dot before class name
								objectFit: 'contain',
								width: '100%', // Make image fill the avatar container
							},
						}}
					/>
				</Stack>

				<Typography sx={{ fontWeight: 700, fontSize: { xs : '24px', md : '32px' }, textAlign: 'center' }}>Hang tight — we’re about to ring you.</Typography>

				<Typography sx={{ fontWeight: 400, fontSize: { xs : '14px', md : '18px' }, textAlign: 'center', color: '#777777' }} mb={2}>
					Your call request has been successfully submitted.
				</Typography>
			</Stack>

			<Stack direction="column" spacing={2} px={{ xs: 1, md: '102px' }}>
				<Stack sx={{ display: 'flex', flexDirection: { xs : 'column', md : 'row'}, gap: 1, alignItems: 'start', justifyContent: 'space-between' }}>
					<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Name</Typography>
					<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>
						{employee?.firstName + ' ' + employee?.lastName}
					</Typography>
				</Stack>
				<Stack sx={{ display: 'flex', flexDirection: { xs : 'column', md : 'row'},gap: 1, alignItems: 'start', justifyContent: 'space-between' }}>
					<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Email </Typography>
					<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{employee?.email}</Typography>
				</Stack>

				<Stack sx={{ display: 'flex', flexDirection: { xs : 'column', md : 'row'},gap: 1, alignItems: 'start', justifyContent: 'space-between' }}>
					<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Department </Typography>
					<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{employee?.department}</Typography>
				</Stack>

				<Stack sx={{ display: 'flex', flexDirection: { xs : 'column', md : 'row'},gap: 1, alignItems: 'start', justifyContent: 'space-between' }}>
					<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Selected Agent</Typography>
					<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{selectedAssistant}</Typography>
				</Stack>

				<Stack sx={{ display: 'flex', flexDirection: { xs : 'column', md : 'row'},gap: 1, alignItems: 'start', justifyContent: 'space-between' }}>
					<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Phone Number</Typography>
					<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{employee?.phoneNumber || phoneNumber}</Typography>
				</Stack>

			</Stack>

			<Card sx={{ bgcolor: '#ffffff', borderRadius: 2, boxShadow: 0, width: '100%', mt: { xs : 2 , md : 4 } }}>
				<Typography sx={{ fontWeight: 600, fontSize: '14px' }}>While You Wait…</Typography>
				<Typography sx={{ fontWeight: 500, fontSize: '14px', fontStyle: 'italic' }}>
					“Sometimes, just saying it out loud is the first step to feeling better.” — Someone wise (and probably right)
				</Typography>
			</Card>
		</CardContent>
	</Card>
);

export default CallSubmittedCard;
